import { FC } from 'react';

import Picture from '@components/controls/future/Picture';

import { transformImageUrl } from '@scripts/helpers';

import PhoneIcon from '@icons/18/phone.svg';
import MailIcon from '@icons/mail.svg';

import { CONTACTS_IMAGES_BASE_URL } from '../../constants';
import styles from './RequisitesSection.module.scss';
import { RequisitesSectionProps } from './types';

const RequisitesSection: FC<RequisitesSectionProps> = ({
    companyTitle,
    lines,
    sideTitle,
    sideIntro,
    sideBullets,
    sideText,
    sidePhoneLabel,
    sidePhoneTel,
    sideEmail,
    hideTitle = false,
}) => (
    <section className={styles.requisites_section} aria-labelledby="contacts-requisites-heading">
        {!hideTitle ? (
            <h2 id="contacts-requisites-heading" className={styles.requisites_sectionTitle}>
                Реквизиты
            </h2>
        ) : null}
        <div className={styles.requisites_row}>
            <article className={styles.requisites_card}>
                <h3 className={styles.requisites_cardTitle}>{companyTitle}</h3>
                <ul className={styles.requisites_list}>
                    {lines.map(line => (
                        <li key={line} className={styles.requisites_listItem}>
                            {line}
                        </li>
                    ))}
                </ul>
            </article>
            <div className={styles.requisites_aside}>
                <div className={styles.requisites_asideContent}>
                    <h3 className={styles.requisites_asideTitle}>{sideTitle}</h3>
                    <div>
                        <p className={styles.requisites_asideText}>{sideIntro}</p>
                        <ul className={styles.requisites_asideBullets}>
                            {sideBullets.map(item => (
                                <li key={item} className={styles.requisites_asideBullet}>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <p className={styles.requisites_asideText}>{sideText}</p>
                    <div className={styles.requisites_contacts}>
                        <div className={styles.requisites_contactRow}>
                            <span className={styles.requisites_contactIcon} aria-hidden>
                                <PhoneIcon className={styles.requisites_contactIconSvg} />
                            </span>
                            <a href={`tel:${sidePhoneTel}`} className={styles.requisites_link}>
                                {sidePhoneLabel}
                            </a>
                        </div>
                        <div className={styles.requisites_contactRow}>
                            <span className={styles.requisites_contactIcon} aria-hidden>
                                <MailIcon className={styles.requisites_contactIconSvg} />
                            </span>
                            <a href={`mailto:${sideEmail}`} className={styles.requisites_link}>
                                {sideEmail}
                            </a>
                        </div>
                    </div>
                </div>
                <div className={styles.requisites_imageWrap} aria-hidden>
                    <div className={styles.requisites_image}>
                        <Picture
                            sources={[
                                {
                                    media: '',
                                    image: transformImageUrl(
                                        `${CONTACTS_IMAGES_BASE_URL}/contacts-manager-photo.png`,
                                        327,
                                        320
                                    ),
                                },
                            ]}
                            alt=""
                            width={327}
                            height={320}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                            loading="lazy"
                            placeholder="empty"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default RequisitesSection;
